var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "warning_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "warning_svg__warning"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3M12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m1 4h-2v-2h2z",
    className: "warning_svg__vector"
  }))));
};
export { SvgWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGFzcz0id2FybmluZyI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNNC40NyAyMWgxNS4wNmMxLjU0IDAgMi41LTEuNjcgMS43My0zTDEzLjczIDQuOTljLS43Ny0xLjMzLTIuNjktMS4zMy0zLjQ2IDBMMi43NCAxOGMtLjc3IDEuMzMuMTkgMyAxLjczIDNaTTEyIDE0Yy0uNTUgMC0xLS40NS0xLTF2LTJjMC0uNTUuNDUtMSAxLTFzMSAuNDUgMSAxdjJjMCAuNTUtLjQ1IDEtMSAxWm0xIDRoLTJ2LTJoMnYyWiIgY2xhc3M9InZlY3RvciIvPjwvZz48L3N2Zz4=";